import ajax from '@/utils/ajax';
import { data } from 'autoprefixer';

export const head = '/web';

// 添加学情调研表
export const reqLearnSurvey = (data) => ajax(`${head}/v1/user-learn-survey`, data, 'POST');


// 获取当前用户所在班级列表
export const reqUserClass= (data) => ajax(`${head}/v1/class-user/user-class-list`);


// 查询用户是否已完成学情调研
export const reqLearnSurveyComplete= (data) => ajax(`${head}/v1/user-learn-survey/complete`);


// 通过id获取班级表详情
export const reqClassInfo= (id) => ajax(`${head}/v1/class-info/${id}`);

// 获取用户所需填写的问卷
export const reqQuestionnaireList = (classId) => ajax(`${head}/statistics/customize-form-answer/list/${classId}`);
